import Vue from 'vue'
import App from './App.vue'
import less from 'less'
import router from "./router";
import store from "./store";
import filters from "./filters";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {global} from '@/global/global'
import './components';
import auth from "plus/auth";
import DateTimePicker from "@/components/DateTimePicker";
import api from 'plus/api'

Vue.config.productionTip = false
Vue.use(less)
Vue.use(auth);
Vue.component("DateTimePicker", DateTimePicker);
Vue.$api = Vue.prototype.$api = api
ElementUI.Message.hint = function (message) {
    this({
        message,
        type: 'success',
        offset: 300,
        customClass: 'hint',
        showClose: true,
    })
}
Vue.use(ElementUI);
for (var key in filters) {
    Vue.filter(key, filters[key]);
}
// 加载用户主题
if (localStorage.getItem('themeValue')) {
    global.changeTheme(localStorage.getItem('themeValue'))
} else {
    global.changeTheme('default')
}
new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});
